import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { useAppDispatch } from 'careand-redux/useAppDispatch';
import { api } from 'careand-redux/api/ApiThunks';
import DefaultButton from 'components/Utils/NewDefaultButton';
import Icon from 'components/Utils/NewIcon';
import DefaultPatientTextField from 'components/Utils/DefaultPatientTextField';
import { promoCodeSchema, PromoCodeValues } from 'types/forms';

const PromoCodeFields = ({
  patient,
  onSuccess,
  referral,
}: {
  patient: any;
  onSuccess?: (result: any) => void;
  referral?: boolean;
}) => {
  const dispatch = useAppDispatch();
  const [submitting, setSubmitting] = useState(false);

  const { control, handleSubmit, reset } = useForm<PromoCodeValues>({
    resolver: zodResolver(promoCodeSchema),
    defaultValues: { code: '' },
  });

  const codeType = referral ? 'Referral' : 'Promo';

  async function onApplyPromoCode(values: PromoCodeValues) {
    const { code } = values;

    setSubmitting(true);
    const result = await dispatch(
      api.Payments.applyPromoCode({ patientId: patient.id, promoCode: code }),
      {
        title: `${codeType} Code`,
        successText: `${codeType} Code applied successfully!`,
      },
    );
    setSubmitting(false);
    if (result) {
      reset();
      if (onSuccess) onSuccess(result);
    }
  }

  return (
    <form onSubmit={handleSubmit(onApplyPromoCode)} className="promo-code-fields text-center">
      <Icon src="tag" className="blue my-3" width="100px" />
      <span className="text-center mb-5 block">
        Please add your {codeType.toLowerCase()} code below
      </span>
      <DefaultPatientTextField
        name="code"
        control={control}
        placeholder={`${codeType} Code`}
        style={{ width: '100%' }}
      />
      <div>
        <DefaultButton
          id="promo-code-button"
          name={`Apply ${codeType} Code`}
          loading={submitting}
          style={{ width: '100%', marginTop: '20px' }}
        />
      </div>
    </form>
  );
};

export default PromoCodeFields;
